<template>
<div> 
<b-modal id="modal-sm" size="md" title="Manage Tax Standard" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
            <div slot="default">
                <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
                <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
            </div> 
            <div slot="modal-footer" class="w-100">
                <p class="float-left" variant="primary"></p>
                <b-button variant="primary"  size="md"  class="float-right"  @click="TaxStandardExit"> Close </b-button>
            </div>
</b-modal>
<form>  
  <div class="form-group row  my-1">
    <label for="texttype" class="col-sm-4 label-small my-0">Tax Type:</label>
    <div class="col-sm-4 my-0">
	   <input id="TaxType" type="text" :disabled="this.taxid!=undefined" maxlength="3" v-model="taxtype" placeholder="Tax Type" class="form-control form-control-xs my-0 mb-0"> 
    </div>
    <div calss="col-sm-4 my-0"   v-show="$v.taxtype.$error" :class="{ 'col-sm-4 my-0': $v.taxtype.$error}"  >
       <div class="row">
        <small class="sml-red" v-if="!$v.taxtype.required">Tax Type is required.</small>
       </div> 
    </div>
  </div>
<div class="form-group row  my-0">
    <label for="Per" class="col-sm-4  label-small my-0">Percentage: </label>
    <div class="col-sm-4 my-0">
        <input id="Per" :disabled="this.taxid!=undefined && (iseffective || isExpired)" maxlength="4"  v-model="percentage" placeholder="Tax Percentage" class=" my-0 form-control form-control-xs">
     <!-- <small class="sml">Must be 12 charactor long.Must be Alpha numaric and special character.</small> -->
    </div>
    <div :class="{ 'col-sm-4 my-0': $v.percentage.$error}"   v-show="$v.percentage.$error">
        <div class="row">
         <small class="sml-red" v-if="!$v.percentage.required">Tax Percentage is required. 
         </small>
        </div> 
        <!-- <div class="row mb-0">
         <small class="sml-red" v-if="!$v.percentage.maxValue">Tax Percentage cannont be > 100. 
           </small>
        </div >		 -->
        <div class="row mb-0">
         <small class="sml-red" v-if="!$v.percentage.isPercent">Tax Percentage can only have 1 decimal or not greater than 100. 
           </small>
        </div >		            
    </div>
  </div>
	<div class="form-group row  my-0">
		<div class="col-sm-4 my-0"></div>
		<div class="col-sm-8 mr-0 my-0">
		  <small class="sml-red">(Example: 5.5)</small>
		</div>
	</div>
	<div class="form-group row  my-0 mb-0 mt-1">
    <label class="col-sm-4 label-small mb-0">Effective Date:</label>
    <div class="col-sm-4 ">
       <div>
	   <datepicker class="servdatapick" :disabled="this.taxid!=undefined && (iseffective || isExpired)"  typeable :open-date="new Date()" :disabledDates="{ to: new Date(Date.now()) }" v-model="effectivedate" :format="dateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass" name="effectiveDatepicker">
 	   </datepicker>
	   </div>
    </div>
       <div class="col-sm-4 mb-0" v-show="$v.effectivedate.$error" :class="{ 'col-sm-4 mb-0': $v.effectivedate.$error}"  > 
          <div class="row mb-0">
         <small class="sml-red" v-if="!$v.effectivedate.required">Effective Date is required.
           </small>
        </div > 
       </div>
	</div>   
 
   <div class="form-group row  my-0 mb-0 mt-1">
    <label class="col-sm-4 label-small mb-0">Expiry Date:</label>
    <div class="col-sm-4 ">
       <div>
	    <datepicker class="servdatapick" :disabled="this.taxid!=undefined &&  isExpired" typeable :open-date="new Date()" :disabledDates="{ to: new Date(Date.now()) }" v-model="expirydate" :format="dateFormat" id="ExpDate" :bootstrap-styling="true" :input-class="datapickClass" name="expirydatepicker">
		</datepicker> 
	   </div>
    </div>
       <div :class="{ 'col-sm-4 mb-0': $v.expirydate.$error}"  v-show="$v.expirydate.$error"> 
         <div class="row mb-0">
         <small class="sml-red" v-if="!$v.expirydate.required">Expiry Date is required.
           </small>
        </div >
		<div class="row mb-0">
         <small class="sml-red" v-if="!$v.expirydate.minValue">Expiry Date can't be in the past.
           </small>
        </div >		
       </div>
	</div>
  <hr>
	<div class="row" >
    <div class="col-sm-6" >
        <button v-on:click="SavePopup" type="button" class="btn BtnSave btn-sml"><i :class="saveIcon"></i>{{saveBtnName}}</button>
    </div>
    <div class="col-sm-6">
        <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
    </div>
	</div>  
</form>
</div>  
</template>
<script>

import {mapGetters} from 'vuex'
import axios from 'axios'
import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';
import Vuelidate from 'vuelidate'
import moment from 'moment'
import Modal from '../../../Common/ModelPop.vue'
import { helpers } from 'vuelidate/lib/validators'
const isPercent = helpers.regex('alphaNum', /100$|^[0-9]{1,2}$|^[0-9]{0,2}\.[0-9]{1}$/)
//import { PopUpVariant } from '@/Common/Default/PopUpVariant'
Vue.use(Vuelidate)
import { required, minLength, maxLength, between,withParams,email, maxValue} from 'vuelidate/lib/validators'
export default {  
    data: function() {
    return {
        saveIcon:'fas fa-plus',
        saveBtnName:'Add Tax',
        taxid:'',
        taxtype:'',
        percentage:'',
        effectivedate:'',
        expirydate:'',
        DbKey :'',   
        AppServiceID :6,
        showModal:false,
        succeeded:true,
        dateFormat:'',
        Msg:'', 
        isModalVisible: true,
        showModal: false,
        columns: ['edit','taxtype','percentage','effectivedate','expirydate'],
        tableData: [],//getData(),
        datapickClass:"form-control form-control-xs my-0", 
        isExpired:false,
        iseffective:false
      }     
    },
    components: {

        //Modal:Modal
        Datepicker
        //EditTaxStandard:EditTaxStandard
        //AddTaxstd:AddTaxstd
    },
    props:{
        //AllowEdit:'',
        UserData:'',
        mode:''
    },
    
    created: function() {
        if(this.UserData.taxid !=undefined || this.UserData.taxid !=null)
        {
           this.saveIcon = 'far fa-edit';
           this.saveBtnName ='Edit Tax';
        }
        this.taxid = this.UserData.taxid;    
        this.taxtype = this.UserData.taxtype; 
        this.percentage = this.UserData.percentage==undefined?0.0:parseFloat((this.UserData.percentage * 100).toFixed(3));  
        //this.effectivedate = this.UserData.effectivedate;
        // this.expirydate = this.UserData.expirydate;
        if (this.UserData.effectivedate==undefined)
          this.effectivedate=moment(new Date()).add('days',1).format('YYYY/MM/DD');
        else
          this.effectivedate = moment(this.UserData.effectivedate).format('YYYY/MM/DD');
        this.expirydate = moment(this.UserData.expirydate==undefined?'9999/12/31':this.UserData.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
        this.DbKey = this.UserData.dbkey;
        this.dateFormat = this.$store.getters.GetDateFormat; 
        this.isExpired = (moment(this.expirydate)).startOf('day').toISOString() <= moment().startOf('day').toISOString();
        this.iseffective = (moment(this.effectivedate)).startOf('day').toISOString() <= moment().startOf('day').toISOString();
        },
     methods: {
        EditTax: function(){
            var vm = this; 
            var url = "SaskHealthApi/Host/PostEditTaxes/"            
            var params = {
                "_": Date.now(), 
                "TaxID": vm.taxid,
                "Tax": vm.taxtype,
                "percent": vm.percentage,
                "EffectiveDate": vm.effectivedate,
                "ExpiryDate": vm.expirydate,
                "DbKey" : vm.DbKey                
                }    
            axios({
              method: 'post',
              url: url,
              headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
              data: params
            }).then(function (response) {
                console.log(response)
                                vm.succeeded = true;
                                vm.Msg="Tax Standard Successfully Updated For " +  vm.taxtype.toUpperCase()+"."; 
                                vm.showModal=true;
                })
                .catch(function (er) {
                  if(er.response.status ==400)
                  {
                    vm.showModal = true; 
                    vm.succeeded = false;
                    vm.Msg="Warning: Tax Standard Not Successfully Updated For " +  vm.taxtype.toUpperCase()+" ( " + er.response.data.message + ").";  
                  }
                  else if(er.response.status == 500)
                  {
                    vm.showModal = true;                          
                    // if(er.response.data.message !=null)
                    // vm.Msg = er.response.data.message;
                    // else
                    vm.Msg = "Network Related Error ! Please contact system administrator." 
                  }                 
             
                })
                .then(function () {
                });           
        },
        AddTax :function()
        {
            var vm = this; 
            var url = "SaskHealthApi/Host/PostAddTaxes/"
            var params = {
                "_": Date.now(), 
                "Tax": vm.taxtype,
                "percent": vm.percentage,
                "EffectiveDate": vm.effectivedate,
                "ExpiryDate": vm.expirydate,
                "DBKey" : vm.DbKey                
                }                 
           axios({
              method: 'post',
              url: url,
              headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
              data: params
            }).then(function (response) {
                  console.log(response)
                    vm.succeeded = true;
                    vm.Msg="Tax Standard Successfully Saved For " +  vm.taxtype.toUpperCase()+".";                            
                    vm.showModal=true;                                   
                })
                .catch(function (er) {
                  if(er.response.status ==400)
                  {
                    vm.showModal = true; 
                    vm.succeeded = false;
                    vm.Msg="Warning: Tax Standard Not Successfully Updated For " +  vm.taxtype.toUpperCase()+" ( " + er.response.data.message + ").";  
                  }
                  else if(er.response.status == 500)
                  {
                    vm.showModal = true;                          
                    // if(er.response.data.message !=null)
                    // vm.Msg = er.response.data.message;
                    // else
                    vm.Msg = "Network Related Error ! Please contact system administrator." 
                  }  
                })
                .then(function () {
                }); 
        },
        ClosePopup: function() {     
            this.$root.$emit('bv::hide::modal', 'editModal', '#btnShow') 
            this.$v.$reset();
        },
        SavePopup: function(){
          this.$v.$touch();
          if (!this.$v.$invalid){
          //Add New Tax record  
              if(this.UserData.taxid == undefined)         
              {
                this.AddTax();
              }
              //Edit Tax Standard code
              if(this.taxid != undefined)
              {
                this.EditTax();
              }
          }
        },
        TaxStandardExit: function(){
            this.showModal=false;
            if(this.succeeded)
            {
              this.$root.$emit('bv::hide::modal', 'editModal', '#btnShow');   
              this.$emit('taxUpdated');
              // this.$v.$reset(); 
            }
            else
            {
               this.showModal=false;
            }
        },
    },

  validations(){
      return {
                    
              taxtype:{
                  required
              },
              percentage:{
                  required,
                 //between: between(0.1,100),
                 //maxValue: maxValue("100"),
                  isPercent      
              },
              effectivedate:{
                  required
              },
              expirydate:{
                  required,
                  minValue: value => (moment(this.expirydate)).toISOString() >= moment(new Date()).startOf('day').toISOString()
              }
           
      }
    }
    
}
</script>
<style> 

</style>